export default __webpack_public_path__ + "static/media/cross-road.634e8583.png";